import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { GeneralRouteV2Id } from 'routes/routesConfigV2';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import SunLifeInitiateProposalPageStore, {
  SunLifeInitiateProposalPageStoreContext,
  useSunLifeInitiateProposalPageStore,
} from 'store/pages/initiate-quote/sunLife/pageStore';
import { useParams } from 'react-router-dom';
import SunLifeInitiateProposalForm from 'components/initiate-quote/SunLife';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate: { isInitialDataLoading, groupInfoDelegate, isFlowDataLoading },
    isActionLoading,
    canCompleteStep,
    proposalFormDelegate,
    domainParams: { groupId },
    getInitialData,
    saveProposal,
  } = useSunLifeInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  const moreInfoBlob = groupInfoDelegate.moreInfoBlobInput
    ? buildGroupContextMoreInfoBlobProps(groupInfoDelegate.moreInfoBlobInput)
    : undefined;

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ groupId }}
      pageId={GeneralRouteV2Id.INITIATE_PROPOSAL}
      pageHeader={{ subtitleMaxWidth: '46rem' }}
      isInitialLoading={isInitialDataLoading}
      isInfoSectionLoading={isFlowDataLoading}
      isActionLoading={isActionLoading}
      moreInfoBlob={moreInfoBlob}
      pageFooter={{
        onComplete: saveProposal,
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <SunLifeInitiateProposalForm proposalFormDelegate={proposalFormDelegate} />
    </PageInFlowNoSidebarLayout>
  );
});

const SunLifeInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new SunLifeInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <SunLifeInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </SunLifeInitiateProposalPageStoreContext.Provider>
  );
};

export default SunLifeInitiateProposalPage;
